import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './UserSettingsPopup.css';
import { getIsAuthenticated, logoutUser } from '../../store/slices/userSlice';
import { setUserSettingsPopupIsOpen } from '../../store/slices/appSlice';
import { useSelector } from 'react-redux';
import { useLogoutMutation } from '../../store/slices/apiSlice';
import { useAppDispatch } from '../../store/hooks/hooks';
import { useYandexAuth } from '../../store/hooks/useYandexAuth';
import { setActivePage } from '../../store/slices/appSlice';


const UserSettingsPopup: React.FC = () => {
	const { t } = useTranslation('profile');
	const isAuthenticated = useSelector(getIsAuthenticated);

	const dispatch = useAppDispatch();
	const [logout] = useLogoutMutation();
	const { handleYandexLogin } = useYandexAuth();


	const handleLogout = () => {
		logout().then(() => { console.log("Вылогинились") }).finally(() => dispatch(logoutUser()));
	};

	const handleProfileClick = () => {
		dispatch(setActivePage('userProfile'));
	};

	const popupRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleOutsideClick = (event: MouseEvent) => {
			if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
				dispatch(setUserSettingsPopupIsOpen(false));
			}
		};

		document.addEventListener('mousedown', handleOutsideClick);

		return () => {
			document.removeEventListener('mousedown', handleOutsideClick);
		};
	}, [dispatch]);

	return (
		<div className="user-settings-popup" role="menu" aria-label={t('menu.aria')} ref={popupRef}>
			{!isAuthenticated &&
				<button type="button" role="menuitem" onClick={handleYandexLogin}>
					{t('menu.yandexLogin')}
				</button>
			}
			{
				isAuthenticated && (<>
					<button type="button" role="menuitem" onClick={handleProfileClick}>
						{t('menu.profile')}
					</button>
					<button type="button" role="menuitem" onClick={handleLogout}>
						{t('menu.logout')}
					</button>
				</>
				)
			}
		</div>
	)
}

export default UserSettingsPopup;
